<template lang="pug">
v-container
  v-row(
    align="center"
    justify="center"
    class="my-auto mt-5"
    )
      v-col(md="5")
        div(class="box-shape text-center")
          div(class="pb-5 mb-5")
            h1(class="pb-1" style="font-size:40px;") Forgot Password
            p(
            style="color:#666666; font-weight: 400;") Enter your email address and we will send you a link to reset your password.

          div(class="pb-5")
            v-alert(
              dismissible 
              text 
              color="red" 
              v-if="alert==true") {{errormsg}}

          v-text-field(
            v-model='email' 
            @keyup.enter.native="forgetpassword"  
            label='Email' 
            type='email' 
            outlined 
            :rules="[rules.required, rules.email]"
          )

          v-btn(
            color='blue-primary' 
            type='submit'
            block 
            style="color:white; padding:25px;" 
            :loading='loadingData' 
            :disabled="!formIsValid" 
            @click="forgetpassword"
            class="mt-2"
          ) SEND 
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ForgetPassword",
  data: () => ({
    email: "",
    errormsg: "Authentication Failed",
    rules: {
      required: value => !!value || 'This field is required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid email format'
      },
    },
    alert:false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid () {
      return (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
      )
    },
  },
  mounted() {
    //this.email = this.$route.query.email || '';
  },
  methods: {
    forgetpassword() {
      const { email } = this;

      if (!email) {
        this.showError("Email required")
      }else{
        this.$store.dispatch("ResetPassword", { email })
        .then(res => {
          if (res.statusCode == 400) this.showError("Failed to send notification, please try again later!")
          else {
            this.alert = false
            this.$router.push('/passwordresetstep');
          }
        })
        .catch(message => {
          if(message.response.data.message === "data not found") this.showError("Could not find your email account")
          else if (message.response.data.message ===  "request already sent to your email") this.showError("This email has been sent, please check your message again.")
          else this.showError(message.response.data.error)
        });
      }

      
    },
    showError(message) {
      this.errormsg = message;
      this.alert = true
    }
  },
};
</script>
